'use client'

import { useEffect } from 'react'
import { sendUAConversion } from '@/lib/measurement/ua-client'
import { createClient } from '@/utils/supabase/client'

export function UAContentView({ contentId, description }: { contentId: string; description: string }) {
  useEffect(() => {
    let cancelled = false
    const send = async () => {
      const supabase = createClient()
      const { data: { user } } = await supabase.auth.getUser()
      if (cancelled) return
      sendUAConversion('content_view', {
        content_id: contentId,
        description,
        user_id: user?.id,
      })
    }
    void send()
    return () => {
      cancelled = true
    }
  }, [contentId, description])

  return null
}
